function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else obj[key] = value;
    return obj;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import React, { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import { AnimatePresence, motion } from 'framer-motion';
import { twMerge } from '@stereoagency/tailwind-config';
import { Container } from '../../atoms';
import { Close } from '../../visuals';
import { useKey } from '../../hooks';
import { slowSpring } from '../../motion/transitions';
var fadeInProps = {
    initial: {
        opacity: 0
    },
    exit: {
        opacity: 0
    },
    animate: {
        opacity: 1
    }
};
export default function Modal(param) {
    var _param_type = param.type, type = _param_type === void 0 ? 'content' : _param_type, open = param.open, children = param.children, onClose = param.onClose, _param_noCloseButton = param.noCloseButton, noCloseButton = _param_noCloseButton === void 0 ? false : _param_noCloseButton, _param_className = param.className, className = _param_className === void 0 ? '' : _param_className, _param_contentClassName = param.contentClassName, contentClassName = _param_contentClassName === void 0 ? '' : _param_contentClassName;
    var _useState = _sliced_to_array(useState(false), 2), mounted = _useState[0], setMounted = _useState[1];
    var handleOverlayClick = function handleOverlayClick() {
        onClose === null || onClose === void 0 ? void 0 : onClose();
    };
    var handleCloseClick = function handleCloseClick() {
        onClose === null || onClose === void 0 ? void 0 : onClose();
    };
    useEffect(function() {
        if (typeof window !== 'undefined') {
            setMounted(true);
        }
    }, []);
    useKey('Escape', function(event) {
        event.preventDefault();
        onClose === null || onClose === void 0 ? void 0 : onClose();
    });
    if (!mounted) return null;
    return /*#__PURE__*/ createPortal(/*#__PURE__*/ React.createElement("aside", null, /*#__PURE__*/ React.createElement(AnimatePresence, {
        mode: "wait"
    }, !!open && /*#__PURE__*/ React.createElement(motion.button, _object_spread_props(_object_spread({}, fadeInProps), {
        key: "overlay",
        type: "button",
        className: "fixed z-10 top-0 left-0 w-full h-full bg-fg-base/80",
        transition: slowSpring,
        onClick: handleOverlayClick
    })), !!open && /*#__PURE__*/ React.createElement(motion.div, _object_spread_props(_object_spread({}, fadeInProps), {
        key: "modal",
        className: "fixed z-10 top-0 left-0 w-full h-full flex items-center justify-center pointer-events-none",
        transition: slowSpring
    }), /*#__PURE__*/ React.createElement(Container, {
        name: Modal.name,
        className: "isolate w-full"
    }, /*#__PURE__*/ React.createElement("div", {
        role: "dialog",
        className: twMerge('relative mx-auto w-full max-w-md max-h-[90vh] overflow-auto bg-bg-base rounded-xl pointer-events-auto no-scrollbar', type === 'content' && 'p-8 pt-10 md:p-11 md:pt-12', type === 'more' && 'max-w-xs p-9', className)
    }, !noCloseButton ? /*#__PURE__*/ React.createElement("button", {
        type: "button",
        className: "z-10 absolute right-0 top-0 flex items-center justify-center overflow-hidden rounded-tr-xl",
        onClick: handleCloseClick
    }, /*#__PURE__*/ React.createElement("div", {
        className: "bg-bg-base pt-6 pr-6 pb-7 pl-7 rounded-bl-full"
    }, /*#__PURE__*/ React.createElement(Close, {
        className: "w-[1.375rem] h-[1.375rem]"
    }))) : null, /*#__PURE__*/ React.createElement("div", {
        className: contentClassName
    }, children)))))), document.body);
}

//# sourceMappingURL=Modal.js.map